module.exports = __webpack_public_path__ + "img/hdd-network.2415e66b.svg";